
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import { Tab, Nav } from "react-bootstrap";
import requireAuth from "components/hoc/requireAuth";
import { showModal, getCompetency } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
// import TrainingCompleteness from "components/widgets/stats/TrainingCompleteness";
import CompetencyQualification from "components/widgets/stats/CompetencyQualification";
import CompetencyItem from "./CompetencyItem";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import i18n from "i18next";

class Competency extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // guideFetched: false,
      competencyFetched: false,
      currentTab: "50022",
      tesvikStatus: "true"
    };
  }

  componentDidMount() {
    this.fetchCompetency();
  }

  componentDidUpdate(prevProps, prevState) {
    // if (
    //   this.props.match.params !== prevProps.match.params &&
    //   this.props.match.params.serviceType
    // ) {
    //   this.setState({ currentTab: this.props.match.params.serviceType });
    // }

    if (prevState.currentTab !== this.state.currentTab) {
      this.fetchCompetency();
    }

    if (prevState.tesvikStatus !== this.state.tesvikStatus) {
      this.fetchCompetency();
    }

  }

  fetchCompetency = () => {
    this.props.getCompetency(
      this.state.currentTab,
      this.state.tesvikStatus,
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };
  onSuccess = () => {
    this.props.onProcessEnd();
    let showingPersonnels = [];
    this.props.competency.positionEfficiencies.forEach((pe) => {
      pe.personnels.forEach((p) => {
        showingPersonnels.push(false);
      });
    });
    this.setState({
      competencyFetched: true,
      showingPersonnels,
    });
  };
  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  renderDepartmentName = () => {
    switch (this.state.currentTab) {
      case "50020":
        return i18n.t("10049"); //"MechanicalS";
      case "50021":
        return i18n.t("10050"); //"Body / PaintS";
      case "50022":
        return i18n.t("10047"); //"SalesS";
      case "50023":
        return i18n.t("10048"); //"Service AdministrationS";
      default:
        return i18n.t("10047"); //"SalesS";
    }
  };

  handleTabSelected = (selected) => {
    // console.log(selected);
    this.setState({
      competencyFetched: false,
      currentTab: selected,
    });

    // switch (selected) {
    //   case "rules":
    //     this.fetchRules();
    //     break;
    //   case "docs":
    //     this.fetchDocs();
    //     break;
    //   case "viewDocument":
    //     this.fetchDocument();
    //     break;
    //   default:
    //     return null;
    // }
  };

  renderPositionEfficiencies = () => {
    if (!this.props.competency) return null;
    // console.log(this.props.competency.positionEfficiencies);
    return (
      <tbody>
        {this.props.competency.positionEfficiencies.map((pe, idx) => {
          return (
            <CompetencyItem
              key={pe.id}
              pe={pe}
              idx={idx}
              personnels={
                this.props.competency.positionEfficiencies[idx].personnels
              }
            />
          );
        })}
      </tbody>
    );
  };

  renderTab = (tabName) => {
    if (!this.state.competencyFetched) {
      return null;
    }
    return (
      <div
        className="tab-pane fade show active"
        id="nav-boya"
        role="tabpanel"
        aria-labelledby="nav-boya-tab"
      >
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 mt-4 p-0 dashboardWidgetArea">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="fgaAlert mt-0 navyBlueAlert">
                  <div className="alertIcon">
                    <span className="iconmford fo-icon-directions-car"></span>
                  </div>
                  <div className="alertText">
                    {this.state.currentTab !== "50022" && (
                      <p>
                        {this.props.competency.vehicleCount == null ? i18n.t("10163").replace("_0_", 0) : i18n.t("10163").replace("_0_", this.props.competency.vehicleCount)}

                        {/* Hesaplamalar <b>{this.props.competency.vehicleCount}</b>
                      araç giriş sayısı üzerinden yapılmıştır. */}
                      </p>
                    )}

                    {this.state.currentTab === "50022" && (
                      <>
                        <p>
                          {this.props.competency.vehicleCount == null ? i18n.t("10519").replace("_0_", 0) : i18n.t("10519").replace("_0_", this.props.competency.vehicleCount)}

                          {/* Hesaplamalar aşağıdaki araç satış miktarları üzerinden yapılmıştır */}
                        </p>
                        {this.props.competency.vehicleSales != null && this.props.competency.vehicleSales.map((pe, idx) => {
                          return (
                            <span key={pe.salesType.value} className="mr-3 d-inline-block">
                              {pe.salesType.label} : {pe.vehicleCount}
                            </span>
                          );
                        })}
                      </>
                    )}

                    <p>
                      <Trans desc="ETO:">10164</Trans>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="fgaAlert redAlert">
                  <div className="alertIcon">
                    <span className="iconmford fo-icon-warning"></span>
                  </div>
                  <div className="alertText">
                    <p>
                      {/* * Gelecek Dönem ETO <b>10.07.2020</b> itibariyle devreye
                      alınacaktır. */}
                      {/* <Trans>10165</Trans> */}
                    </p>
                    <p>
                      {/* * Hesaplama sırasında mevcut personel/lerin değer
                      ortalaması alınmıştır. */}
                      <Trans>10166</Trans>
                    </p>
                    <p>
                      {/* * Gerekli personel sayısı 0 olan pozisyonların ağırlıkları
                      diğer yeterlilikler arasında dağıtılmıştır. */}
                      <Trans>10167</Trans>
                    </p>


                   

                    {this.state.tesvikStatus === "true" ?
                    <p className='genwarnComptency'>
                      {/* * Gerekli personel sayısı 0 olan pozisyonların ağırlıkları
                      diğer yeterlilikler arasında dağıtılmıştır. */}
                    { `* Teşviğe dahil olan çalışanlar hesaplamaya dahil edilmiştir.`}
                    </p>: <p style={{color : "#002e6d" , "fontWeight" : "bold"}} >* Hesaplamaya, teşvik kapsamında olmayan çalışanlar da dâhil edilmiştir. Teşvik kapsamında olmayan çalışanlar kırmızı renk ile belirtilmiştir.</p>
                    }

                      {this.state.tesvikStatus === "false" ?
                    <p> 
                    { `* Tüm Organizasyon (Teşvik Dışı Dahil)" tablosunda, teşvike dahil olmayan bayi personellerinin eğitim tamamlama oranları da simülasyon amacıyla bayi ETO hesaplamasına dahil edilmiştir.`}
                    </p> : null
                    }
                    
                    {/* <p>
                      * İlgili personelin üzerine tıklayarak ilgili
                      personel/leri görebilirsiniz.
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3 p-0 dashboardWidgetArea">
            <div className="row d-none d-sm-none d-md-flex d-lg-flex">
              {/* <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-4 p-0">
                    <TrainingCompleteness
                      classNames=" yeterlilikGrafik gelisimPlaniETO"
                      serviceType={this.state.currentTab}
                    />
                  </div>
                </div>
              </div> */}
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-4 p-0">
                    <CompetencyQualification
                      serviceType={this.renderDepartmentName()} 
                      labelTesvikStatus = {this.state.tesvikStatus}
                      Qualification={this.props.competency.qualification}
                      FutureQualification={
                        this.props.competency.futureQualification
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex d-sm-flex d-md-none d-lg-none">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="topGraphicArea">
                  {/* <div
                    className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0"
                    style={{ width: "auto !important" }}
                  >
                    <TrainingCompleteness
                      classNames=" yeterlilikGrafik gelisimPlaniETO"
                      serviceType={this.state.currentTab}
                    />
                  </div> */}
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0">
                    <CompetencyQualification
                      serviceType={this.renderDepartmentName()}
                      labelTesvikStatus = {this.state.tesvikStatus}
                      Qualification={this.props.competency.qualification}
                      FutureQualification={
                        this.props.competency.futureQualification
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row pb-3">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div id="chartdiv" style={{ display: "none" }}></div>
            <table
              className="table display responsive dtYeterlilik dataTable no-footer dtr-none collapsed"
              id="dtYeterlilik"
            >
              <thead>
                <tr>
                  <th className="all">
                    <div className="tableTitle">
                      <Trans desc="Pozisyon">10064</Trans>
                    </div>
                  </th>

                  <th className="all">
                    <div className="tableTitle">
                      <Trans desc="Personel">10174</Trans>
                    </div>
                  </th>
                  <DesktopBreakpoint>
                    <th className="all">
                      <div className="tableTitle">
                        <Trans desc="Ünvan">10074</Trans>
                      </div>
                    </th>
                    <th className="desktop">
                      <div className="tableTitle">
                        <Trans desc="Required Employee">requiredEmployee</Trans>
                      </div>
                    </th>
                    <th className="desktop">
                      <div className="tableTitle">
                        <Trans desc="Gerekli Personel">10169</Trans>
                      </div>
                    </th>
                    <th className="desktop">
                      <div className="tableTitle">
                        <Trans desc="Mevcut Personel">10170</Trans>
                      </div>
                    </th>
                    <th className="desktop">
                      <div className="tableTitle">
                        <Trans desc="Pozisyon Ağırlığı">10171</Trans>
                      </div>
                    </th>
                    <th className="desktop"></th>
                    <th className="all">
                      <div className="tableTitle"></div>
                    </th>
                    <th className="none"></th>
                  </DesktopBreakpoint>
                </tr>
              </thead>
              {this.renderPositionEfficiencies()}
            </table>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4 d-none d-sm-none d-md-flex d-lg-flex">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>

                </li>
                <li>
                  <a href="#" style={{ verticalAlign: "middle" }}>
                    <Trans desc="Eğitim ve Gelişim">10025</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Yeterlilik">10037</Trans>
                </li>
              </ul>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4 d-flex d-sm-flex d-md-none d-lg-none">
              <div className="sssBaslik">
                <Trans desc="Yeterlilik">10037</Trans>
              </div>
            </div>
          </div>







{/*           
          <div className="row py-4 bottomRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <Tab.Container
                id="nav-tab"
                defaultActiveKey="50022"
                activeKey={this.state.currentTab}
                onSelect={this.handleTabSelected}
              >
                <nav className="scrollNav">
                  <Nav variant="tabs" role="tablist">
                    <Nav.Item>
                      <Nav.Link
                        onClick={() => this.setState({ currentTab: "50022" })}
                        eventKey="50022"
                      >
                        <span className="iconmford fo-icon-directions-car"></span>{" "}
                        <Trans desc="Satış">10047</Trans>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className="nav-item nav-link"
                        onClick={() => this.setState({ currentTab: "50023" })}
                        eventKey="50023"
                      >
                        <span className="iconmford fo-icon-perm-data-setting"></span>{" "}
                        <Trans desc="Servis İdari">10048</Trans>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className="nav-item nav-link"
                        onClick={() => this.setState({ currentTab: "50021" })}
                        eventKey="50021"
                      >
                        <span className="iconmford fo-icon-format-paint"></span>{" "}
                        <Trans desc="Kaporta / Boya">10050</Trans>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className="nav-item nav-link"
                        onClick={() => this.setState({ currentTab: "50020" })}
                        eventKey="50020"
                      >
                        <span className="iconmford fo-icon-build"></span>{" "}
                        <Trans desc="Mekanik">10049</Trans>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </nav>
                <Tab.Content>
                  <Tab.Pane eventKey="50022">
                    {this.renderTab("50022")}
                  </Tab.Pane>
                  <Tab.Pane eventKey="50023">
                    {this.renderTab("50023")}
                  </Tab.Pane>
                  <Tab.Pane eventKey="50021">
                    {this.renderTab("50021")}
                  </Tab.Pane>
                  <Tab.Pane eventKey="50020">
                    {this.renderTab("50020")}
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div> */}

























<div className="row py-4 bottomRow">
  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

    <Tab.Container
      id="nav-tab"
      defaultActiveKey="50022"
      activeKey={this.state.currentTab}
      onSelect={this.handleTabSelected}
    >

      <nav
        className="scrollNav"
        style={{
          width:"100%"
        }}
      >
 


        <div
          style={{
            display:"flex",
            gap:"15px",
            width:"100%",
            marginBottom:"18px",
            flexWrap:"wrap"
          }}
        >
 


          <div
            style={{
              flex:"0 0 580px",
              background:"#ffffff",
              border:"1px solid #E5E7EB",
              borderRadius:"14px",
              padding:"14px",
              boxShadow:"0 2px 8px rgba(0,0,0,.05)"
            }}
          >

            <div
              style={{
                fontSize:"12px",
                fontWeight:"700",
                color:"#475569",
                marginBottom:"10px"
              }}
            >
              Teşvik Durumu
            </div>


            <div
              style={{
                display:"flex",
                background:"#F1F5F9",
                padding:"4px",
                borderRadius:"10px"
              }}
            >


              <button
                type="button"
                onClick={() =>
                  this.setState({
                    tesvikStatus:"true",
                    currentTab:"50022"
                  })
                }
                style={{
                  flex:1,
                  height:"34px",
                  border:"0",
                  borderRadius:"8px",
                  cursor:"pointer",
                  fontSize:"12px",
                  fontWeight:"600",
                  display:"flex",
                  justifyContent:"center",
                  alignItems:"center",
                  gap:"6px",
                  transition:"all .2s",
                  background:
                    this.state.tesvikStatus==="true"
                    ? "#198754"
                    :"transparent",
                  color:
                    this.state.tesvikStatus==="true"
                    ? "#fff"
                    :"#64748B"
                }}
              >

                <span
                  style={{
                    width:"8px",
                    height:"8px",
                    borderRadius:"50%",
                    background:
                      this.state.tesvikStatus==="true"
                      ? "#fff"
                      :"#198754"
                  }}
                ></span>

                Teşviğe Dahil

              </button>



              <button
                type="button"
                onClick={() =>
                  this.setState({
                    tesvikStatus:"false",
                    currentTab:"50022"
                  })
                }
                style={{
                  flex:1,
                  height:"34px",
                  border:"0",
                  borderRadius:"8px",
                  cursor:"pointer",
                  fontSize:"12px",
                  fontWeight:"600",
                  display:"flex",
                  justifyContent:"center",
                  alignItems:"center",
                  gap:"6px",
                  transition:"all .2s",
                  background:
                    this.state.tesvikStatus==="false"
                    ? "#64748B"
                    :"transparent",
                  color:
                    this.state.tesvikStatus==="false"
                    ? "#fff"
                    :"#64748B"
                }}
              >

                <span
                  style={{
                    width:"8px",
                    height:"8px",
                    borderRadius:"50%",
                    background:
                      this.state.tesvikStatus==="false"
                      ? "#fff"
                      :"#94A3B8"
                  }}
                ></span>

                Tüm Organizasyon (Teşvik Dışı Dahil)

              </button>


            </div>


          </div>
 
          <div
            style={{
              flex:1,
              background:"#ffffff",
              border:"1px solid #E5E7EB",
              borderRadius:"14px",
              padding:"14px",
              boxShadow:"0 2px 8px rgba(0,0,0,.05)"
            }}
          >


            <div
              style={{
                fontSize:"12px",
                fontWeight:"700",
                color:"#475569",
                marginBottom:"10px"
              }}
            >
              Servis Tip Seçimi
            </div>


            <Nav
              variant="tabs"
              role="tablist"
              style={{
                display:"flex",
                gap:"8px",
                borderBottom:"0"
              }}
            >


              {[
                {
                  title:"Satış",
                  icon:"fo-icon-directions-car",
                  include:"50022",
                  exclude:"50022"
                },
                {
                  title:"Servis İdari",
                  icon:"fo-icon-perm-data-setting",
                  include:"50023",
                  exclude:"50023"
                },
                {
                  title:"Kaporta / Boya",
                  icon:"fo-icon-format-paint",
                  include:"50021",
                  exclude:"50021"
                },
                {
                  title:"Mekanik",
                  icon:"fo-icon-build",
                  include:"50020",
                  exclude:"50020"
                }
              ].map((item,index)=>{

                const activeKey =
                  this.state.tesvikStatus==="true"
                  ? item.include
                  : item.exclude;


                const isActive =
                  this.state.currentTab === activeKey;


                return (
                    <Nav.Item key={index}>

                    <Nav.Link

                      eventKey={activeKey}

                      onClick={() =>
                        this.setState({
                          currentTab:activeKey
                        })
                      }


                      style={{
                        display:"flex",
                        alignItems:"center",
                        gap:"7px",

                        borderRadius:"10px",

                        padding:"10px 16px",

                        fontSize:"13px",

                        fontWeight:
                          isActive
                          ? "700"
                          : "600",

                        whiteSpace:"nowrap",

                        cursor:"pointer",

                        transition:"all .2s ease",

                        background:
                          isActive
                          ? "#2d96cd"
                          : "#FFFFFF",


                        color:
                          isActive
                          ? "#FFFFFF"
                          : "#475569",


                        border:
                          isActive
                          ? "1px solid #2d96cd"
                          : "1px solid #E2E8F0",


                        boxShadow:
                          isActive
                          ? "0 4px 10px rgba(37,99,235,.25)"
                          : "none"
                      }}

                    >


                      <span
                        className={
                          "iconmford " + item.icon
                        }

                        style={{
                          color:
                            isActive
                            ? "#FFFFFF"
                            : "#2563EB",

                          fontSize:"15px"
                        }}

                      ></span>


                      {item.title}


                    </Nav.Link>


                  </Nav.Item>


                );


              })}


            </Nav>


          </div>


        </div>


      </nav>
 


      <Tab.Content>


        <Tab.Pane eventKey="50022">
          {this.renderTab("50022")}
        </Tab.Pane>


        <Tab.Pane eventKey="50023">
          {this.renderTab("50023")}
        </Tab.Pane>


        <Tab.Pane eventKey="50021">
          {this.renderTab("50021")}
        </Tab.Pane>


        <Tab.Pane eventKey="50020">
          {this.renderTab("50020")}
        </Tab.Pane>



        <Tab.Pane eventKey="60001">
          {this.renderTab("60001")}
        </Tab.Pane>


        <Tab.Pane eventKey="60002">
          {this.renderTab("60002")}
        </Tab.Pane>


        <Tab.Pane eventKey="60003">
          {this.renderTab("60003")}
        </Tab.Pane>


        <Tab.Pane eventKey="60004">
          {this.renderTab("60004")}
        </Tab.Pane>


      </Tab.Content>


    </Tab.Container>


  </div>
</div>








































        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    application: state.application,
    competency: state.competency.data,
  };
};

export default connect(mapStateToProps, { getCompetency, showModal })(
  requireAuth(containsLongRunningProcess(Competency))
);
